export enum JoinLinks {
  JoinTile = 'MenuTiles',
  IDontKnowYetLink = 'IDontKnowYet',
}
